
/*
  File: {file_name}
  Author: Binish Mookken
  Date: April-June 2024

  Description:

*/


/*
  File: Login.css
  Author: Binish Mookken
  Date: April-June 2024

  Description:

*/

import { Button } from "antd";

interface LetterFilterProps {
  selectedLetters: string[];
  handleLetterClick: (letter: string) => void;
  countUsersByLetter: (letter: string) => number;
}

const LettersFilter: React.FC<LetterFilterProps> = ({
  selectedLetters,
  handleLetterClick,
  countUsersByLetter,
}) => (
  <div className="letters-container">
    {Array.from(Array(26), (_, i) => String.fromCharCode(65 + i)).map(
      (letter) => (
        <Button
          key={letter}
          type={selectedLetters.includes(letter) ? "primary" : "default"}
          onClick={() => handleLetterClick(letter)}
          disabled={countUsersByLetter(letter) === 0}
          style={{ fontFamily: "Ubuntu" }}
        >
          <span style={{ fontWeight: 700 }}>{letter}</span> &nbsp;
          <span style={{ color: "gray", fontSize: "11px", fontWeight: 700 }}>
            {countUsersByLetter(letter)}
          </span>
        </Button>
      )
    )}
  </div>
);

export default LettersFilter;
